var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$auth.loading && _vm.$auth.isAuthenticated)?_c('LoggedInStart'):_c('LoggedOutStart')
}
var staticRenderFns = []

export { render, staticRenderFns }